export const SKILL_CATEGORIES: ReadonlyArray<{ label: string; skills: ReadonlyArray<string> }> = [
  {
    label: 'Languages',
    skills: [
      'JavaScript', 'TypeScript', 'Python', 'Go', 'Rust', 'Java', 'Kotlin', 'Swift',
      'C', 'C++', 'C#', 'Ruby', 'PHP', 'Dart', 'Elixir', 'Erlang', 'Haskell', 'Scala',
      'Clojure', 'Lua', 'R', 'MATLAB', 'Julia', 'Perl', 'Shell', 'Bash', 'PowerShell',
      'SQL', 'GraphQL', 'HTML', 'CSS', 'Sass', 'Less', 'Markdown', 'YAML', 'TOML', 'JSON',
      'Objective-C', 'Solidity', 'OCaml', 'F#', 'Groovy', 'Assembly',
    ],
  },
  {
    label: 'Frontend',
    skills: [
      'React', 'Next.js', 'Remix', 'Vue', 'Nuxt', 'Svelte', 'SvelteKit', 'Angular',
      'Solid', 'Qwik', 'Astro', 'Gatsby', 'Ember', 'Preact', 'Lit', 'Alpine.js',
      'Tailwind CSS', 'CSS Modules', 'styled-components', 'Emotion', 'Chakra UI',
      'Material UI', 'Radix UI', 'Shadcn UI', 'Bootstrap', 'Bulma', 'Ant Design',
      'Framer Motion', 'GSAP', 'Three.js', 'React Three Fiber', 'D3.js', 'Recharts',
      'Chart.js', 'Redux', 'Zustand', 'Jotai', 'Recoil', 'MobX', 'TanStack Query',
      'SWR', 'React Router', 'TanStack Router', 'Storybook', 'Webpack', 'Vite',
      'Rollup', 'esbuild', 'Turbopack', 'Parcel', 'PWA', 'Web Components',
    ],
  },
  {
    label: 'Backend',
    skills: [
      'Node.js', 'Deno', 'Bun', 'Express', 'Fastify', 'NestJS', 'Koa', 'Hapi',
      'Hono', 'tRPC', 'Apollo Server', 'GraphQL Yoga', 'Django', 'Flask', 'FastAPI',
      'Starlette', 'Tornado', 'Rails', 'Sinatra', 'Spring Boot', 'Quarkus', 'Micronaut',
      'ASP.NET', '.NET Core', 'Laravel', 'Symfony', 'Gin', 'Echo', 'Fiber', 'Chi',
      'Actix', 'Axum', 'Rocket', 'Phoenix', 'Ktor', 'Vapor', 'Buffalo',
      'REST APIs', 'gRPC', 'WebSockets', 'Server-Sent Events', 'OpenAPI', 'Swagger',
      'OAuth', 'JWT', 'SAML', 'OIDC',
    ],
  },
  {
    label: 'Mobile',
    skills: [
      'React Native', 'Expo', 'Flutter', 'SwiftUI', 'UIKit', 'Jetpack Compose',
      'Android SDK', 'iOS', 'Ionic', 'Capacitor', 'Cordova', 'NativeScript',
      'Kotlin Multiplatform', 'MAUI', 'Xamarin',
    ],
  },
  {
    label: 'Databases',
    skills: [
      'PostgreSQL', 'MySQL', 'SQLite', 'MariaDB', 'MongoDB', 'Redis', 'Cassandra',
      'DynamoDB', 'Firestore', 'Supabase', 'CockroachDB', 'PlanetScale', 'Neon',
      'Turso', 'Elasticsearch', 'OpenSearch', 'Meilisearch', 'Algolia', 'Typesense',
      'Neo4j', 'ArangoDB', 'InfluxDB', 'TimescaleDB', 'ClickHouse', 'Snowflake',
      'BigQuery', 'Redshift', 'Databricks', 'DuckDB', 'Prisma', 'Drizzle', 'TypeORM',
      'Sequelize', 'Mongoose', 'Knex', 'SQLAlchemy', 'Hibernate', 'Dapper',
    ],
  },
  {
    label: 'DevOps & Cloud',
    skills: [
      'AWS', 'Google Cloud', 'Azure', 'Cloudflare', 'Vercel', 'Netlify', 'Fly.io',
      'Railway', 'Render', 'Heroku', 'DigitalOcean', 'Linode', 'Hetzner',
      'Docker', 'Podman', 'Kubernetes', 'Helm', 'Terraform', 'Pulumi', 'Ansible',
      'CloudFormation', 'CDK', 'Nomad', 'Consul', 'Vault', 'Packer',
      'GitHub Actions', 'GitLab CI', 'CircleCI', 'Jenkins', 'Travis CI', 'Buildkite',
      'ArgoCD', 'Flux', 'Spinnaker', 'Nginx', 'Caddy', 'HAProxy', 'Traefik',
      'Prometheus', 'Grafana', 'Datadog', 'New Relic', 'Sentry', 'OpenTelemetry',
      'Kafka', 'RabbitMQ', 'NATS', 'BullMQ', 'SQS', 'Pub/Sub',
      'S3', 'R2', 'Cloudflare Workers', 'AWS Lambda', 'Edge Functions',
      'Linux', 'Unix', 'Git',
    ],
  },
  {
    label: 'Data & AI',
    skills: [
      'Machine Learning', 'Deep Learning', 'PyTorch', 'TensorFlow', 'JAX', 'Keras',
      'scikit-learn', 'Pandas', 'NumPy', 'SciPy', 'Matplotlib', 'Seaborn', 'Plotly',
      'Jupyter', 'Hugging Face', 'LangChain', 'LlamaIndex', 'OpenAI API', 'Anthropic API',
      'Claude', 'GPT', 'Gemini', 'Ollama', 'vLLM', 'RAG', 'Vector Databases',
      'Pinecone', 'Weaviate', 'Qdrant', 'Chroma', 'pgvector', 'Milvus',
      'Computer Vision', 'NLP', 'Reinforcement Learning', 'MLOps', 'Kubeflow',
      'MLflow', 'Weights & Biases', 'Airflow', 'Dagster', 'dbt', 'Prefect',
      'Apache Spark', 'Apache Beam', 'Flink', 'Hadoop', 'ETL', 'Data Modeling',
    ],
  },
  {
    label: 'Testing & QA',
    skills: [
      'Jest', 'Vitest', 'Mocha', 'Jasmine', 'Cypress', 'Playwright', 'Puppeteer',
      'Testing Library', 'Selenium', 'WebdriverIO', 'Appium', 'Detox', 'Maestro',
      'Pytest', 'unittest', 'RSpec', 'JUnit', 'Mockito', 'TestNG', 'xUnit',
      'k6', 'Locust', 'JMeter', 'Postman', 'Insomnia', 'Hoppscotch',
      'TDD', 'BDD', 'Unit Testing', 'Integration Testing', 'E2E Testing',
      'Visual Regression', 'Accessibility Testing', 'Load Testing',
    ],
  },
  {
    label: 'Design & UX',
    skills: [
      'UI Design', 'UX Design', 'Interaction Design', 'Product Design',
      'Visual Design', 'Typography', 'Color Theory', 'Design Systems',
      'Figma', 'Sketch', 'Adobe XD', 'Framer', 'InVision', 'Zeplin', 'Protopie',
      'Photoshop', 'Illustrator', 'After Effects', 'Premiere Pro', 'Lightroom',
      'Blender', 'Cinema 4D', 'Spline', 'Procreate', 'Affinity Designer',
      'Wireframing', 'Prototyping', 'User Research', 'Usability Testing',
      'Accessibility', 'WCAG', 'Motion Design', 'Illustration', 'Branding',
      'Logo Design', 'Editorial Design', 'Print Design',
    ],
  },
  {
    label: 'Security',
    skills: [
      'Application Security', 'Web Security', 'Network Security', 'Cryptography',
      'Penetration Testing', 'OWASP Top 10', 'Threat Modeling', 'Secure Coding',
      'Authentication', 'Authorization', 'RBAC', 'SSO', 'Zero Trust',
      'SIEM', 'SOC', 'Incident Response', 'Forensics', 'Reverse Engineering',
      'Fuzzing', 'Burp Suite', 'Metasploit', 'Wireshark', 'Nmap', 'Kali Linux',
    ],
  },
  {
    label: 'Product & Collaboration',
    skills: [
      'Product Management', 'Project Management', 'Agile', 'Scrum', 'Kanban',
      'OKRs', 'Roadmapping', 'Stakeholder Management', 'User Stories',
      'Technical Writing', 'Documentation', 'Public Speaking', 'Mentorship',
      'Team Leadership', 'Code Review', 'Pair Programming',
      'Jira', 'Linear', 'Asana', 'Trello', 'Notion', 'Confluence',
      'Slack', 'Microsoft Teams', 'Miro', 'FigJam',
    ],
  },
  {
    label: 'Other',
    skills: [
      'Game Development', 'Unity', 'Unreal Engine', 'Godot', 'Phaser',
      'WebGL', 'WebGPU', 'WebAssembly', 'WebRTC', 'Embedded Systems', 'IoT',
      'Arduino', 'Raspberry Pi', 'Robotics', 'AR/VR', 'Blockchain', 'Ethereum',
      'Smart Contracts', 'Web3', 'Bitcoin', 'SEO', 'Analytics',
      'Google Analytics', 'Mixpanel', 'Amplitude', 'Segment', 'A/B Testing',
      'Growth', 'Marketing Automation',
    ],
  },
];

export const ALL_SKILLS: ReadonlyArray<string> = Array.from(
  new Set(SKILL_CATEGORIES.flatMap((c) => c.skills)),
);
